export default __webpack_public_path__ + "static/media/White_Rabbit_Unlock.8173e889.wav";